import { createFileRoute } from "@tanstack/react-router";
import { TowrVerify } from "@/features/reports/towr-verify";
import { ensureSuperAdminAccess } from "@/lib/route-guards";

// Raport diagnostyczny rozjazdow synchronizacji (sprzedaz bez karty towaru) —
// wylacznie dla super_admin. Swiadomie NIE `ensureElementVisible`: grant na
// `sidebar.raporty.weryfikacja-towr` moze nadac kazdy admin z edytora
// widocznosci, a to ma byc twarda granica, nie ustawienie. Backend trzyma ten
// sam gate (`RequireSuperAdmin` w get_towr_verify, routes/reports.rs).
export const Route = createFileRoute("/_auth/raporty/weryfikacja-towr")({
	beforeLoad: async () => {
		await ensureSuperAdminAccess();
	},
	component: TowrVerify,
});
